<ng-container>
  <div
    class="input-label-field input-label-field--spacingBottom-{{
      spacingBottom
    }} input--{{ direction }} input--error-{{ error }} input--hasLabel-{{
      hasLabel
    }}"
  >
    <div *ngIf="hasLabel" class="input-label-wrapper">
      <label
        class="input-label input-label--base"
        [ngClass]="{ 'input-label--multiline': multiLine }"
        [for]="id"
      >
        {{ label }}
      </label>
      <app-tooltip *ngIf="info" [text]="info"></app-tooltip>
    </div>
    <div class="input-wrapper">
      <input
        *ngIf="!multiLine"
        class="input--base input--size-{{ size }} input--width-{{
          width
        }} input--{{ variant }} input--{{ icon }} input--error-{{ error }}"
        type="{{ type }}"
        [attr.placeholder]="placeholder"
        [attr.data-test-id]="testId"
        [ngModel]="inputValue()"
        [ngClass]="{ 'input--disabled': disabled }"
        [style.padding]="padding"
        (input)="onInputChange($event)"
        autocomplete="off"
        [disabled]="disabled"
        [id]="id"
        (search)="onSearch($event)"
        (blur)="onBlur($event)"
        [maxlength]="maxLength"
        [attr.list]="list"
        (change)="change($event)"
        (focus)="focus($event)"
        [attr.min]="type === 'date' ? minDate : min"
        [attr.max]="max"
        [attr.step]="type === 'number' ? 1 : null"
      />
      <datalist *ngIf="list && listData" [id]="list">
        <option *ngFor="let option of listData">{{ option }}</option>
      </datalist>
      <svg
        *ngIf="icon === InputIcon.SEARCH"
        class="input--icon input--icon-size-{{ size }}"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.16667 1C10.5724 1 13.3333 3.76091 13.3333 7.16667C13.3333 8.5723 12.863 9.86809 12.0712 10.9053C12.1022 10.9278 12.1324 10.9539 12.1611 10.9826L14.7538 13.5753C15.0793 13.9007 15.0793 14.4284 14.7538 14.7538C14.4284 15.0793 13.9007 15.0793 13.5753 14.7538L10.9826 12.1611C10.9539 12.1324 10.9278 12.1022 10.9042 12.0707C9.86809 12.863 8.5723 13.3333 7.16667 13.3333C3.76091 13.3333 1 10.5724 1 7.16667C1 3.76091 3.76091 1 7.16667 1ZM7.16667 2.66667C4.68139 2.66667 2.66667 4.68139 2.66667 7.16667C2.66667 9.65195 4.68139 11.6667 7.16667 11.6667C9.65195 11.6667 11.6667 9.65195 11.6667 7.16667C11.6667 4.68139 9.65195 2.66667 7.16667 2.66667Z"
          fill="#4D5154"
        />
      </svg>
      <button
        *ngIf="showTogglePasswordIcon"
        (click)="togglePassword()"
        class="show-hide-password-icon"
        type="button"
      >
        <svg
          *ngIf="showPassword"
          xmlns="http://www.w3.org/2000/svg"
          height="24px"
          viewBox="0 -960 960 960"
          width="24px"
          fill="#5f6368"
        >
          <path
            d="m644-428-58-58q9-47-27-88t-93-32l-58-58q17-8 34.5-12t37.5-4q75 0 127.5 52.5T660-500q0 20-4 37.5T644-428Zm128 126-58-56q38-29 67.5-63.5T832-500q-50-101-143.5-160.5T480-720q-29 0-57 4t-55 12l-62-62q41-17 84-25.5t90-8.5q151 0 269 83.5T920-500q-23 59-60.5 109.5T772-302Zm20 246L624-222q-35 11-70.5 16.5T480-200q-151 0-269-83.5T40-500q21-53 53-98.5t73-81.5L56-792l56-56 736 736-56 56ZM222-624q-29 26-53 57t-41 67q50 101 143.5 160.5T480-280q20 0 39-2.5t39-5.5l-36-38q-11 3-21 4.5t-21 1.5q-75 0-127.5-52.5T300-500q0-11 1.5-21t4.5-21l-84-82Zm319 93Zm-151 75Z"
          />
        </svg>
        <svg
          *ngIf="!showPassword"
          xmlns="http://www.w3.org/2000/svg"
          height="24px"
          viewBox="0 -960 960 960"
          width="24px"
          fill="#5f6368"
        >
          <path
            d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Zm0-300Zm0 220q113 0 207.5-59.5T832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280Z"
          />
        </svg>
      </button>
      <textarea
        *ngIf="multiLine"
        [id]="id"
        class="input--base input--multiline input--size-{{
          size
        }} input--width-{{ width }} input--{{ variant }} input--{{
          icon
        }} input--error-{{ error }}"
        [attr.placeholder]="placeholder"
        [attr.data-test-id]="testId"
        [ngModel]="inputValue()"
        [ngClass]="{ 'input--disabled': disabled }"
        (input)="onInputChange($event)"
        (blur)="onBlur($event)"
        autocomplete="off"
        [disabled]="disabled"
        [style.padding]="padding"
        [maxlength]="maxLength"
      >
      </textarea>
    </div>
    <p class="input--error-text" *ngIf="errorMessage && error">
      {{ errorMessage }}
    </p>
  </div>
</ng-container>
